import React from 'react';
import SectionCollapse from '../../../../../section/SectionCollapse';
import Chip from '@mui/material/Chip';
import { Typography } from '@mui/material';

const ClassesInformation = ({ type, items = [] }) => {
  return (
    <SectionCollapse title={`${type} (#${items?.length})`}>
      {items?.length > 0 ? (
        <div className='grid grid-cols-4 gap-2'>
          {items?.map((item, index) => (
            <Chip
              key={index}
              id={item.id}
              variant={'rounded'}
              className={['justify-center max-w-200px'].join(' ')}
              component={'span'}
              label={<Typography className='text-ellipsis text-nowrap'>{item?.code}</Typography>}
            />
          ))}
        </div>
      ) : (
        <Typography className='text-muted-foreground opacity-50'>You don't have any classes yet</Typography>
      )}
    </SectionCollapse>
  );
};

export default ClassesInformation;
